<script lang="ts">
    import { _ } from "svelte-i18n"
    import { checkoutData, location } from "../../../store"

    const tabs = [
        {
            name: $_("checkout.info-and-shipping"),
            link: "/checkout",
            step: 0,
        },
        {
            name: $_("checkout.payment"),
            link: "/checkout/payment",
            step: 1,
        },
        {
            name: $_("checkout.summary"),
            link: "/checkout/overview",
            step: 2,
        },
    ]

    let activetab: any
    $: tabs.forEach((t) => {
        if ($location?.path === t.link) {
            activetab = t
        }
        if (!activetab) activetab = tabs[0]
    })
</script>

<ul class="processbar">
    {#each tabs as tab, idx}
        <li class:active="{activetab == tab}" class:checked="{activetab.step > idx}">
            {#if $checkoutData.stepsValid >= idx}
                <a href="{tab.link}"> {tab.name} </a>
            {:else}<span>{tab.name}</span>{/if}
        </li>
    {/each}
</ul>

<style lang="less">
    @import "../../../css/variables.less";

    .processbar {
        overflow: hidden;
        background: var(--surface-4);
        .border-radius(7px);
        height: 40px;
        .flex();
        list-style-type: none;
        margin: 0 0 30px 0;
        padding: 0;
        li {
            .flex();
            flex-direction: column;
            justify-content: stretch;
            a,
            span {
                background: var(--surface-4);
                color: var(--on-surface-4);
                padding: 0px 20px;
                .flex();
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100%;
                line-height: 1;
                @media (max-width: 1600px) {
                    font-size: 0.8rem;
                }
                @media (max-width: 768px) {
                    font-size: 1rem;
                }
            }
            &.active a {
                background: var(--primary);
                color: var(--on-primary);
            }
            &.checked a {
                background: var(--status-green);
                color: var(--status-on-green);
            }
        }
    }
</style>
